import React, {useState, useEffect} from 'react';
import './DirectTestsGrid.css';
import { connect } from 'react-redux';
import ListView from '../../../General/ListView/ListView';
import Post from '../../../../Data/Post';
import MapButtonsToContextMenu from '../../../../Utils/Forms/MapButtonsToContextMenu';
import {InvokeFormHandlerUsingForm, DataRetrievedHandler, PrepareDataFormSavingHandler, NextButtonClickHandler, PreviousButtonClickHandler, FieldContentsChangeHandler} from '../../../../Utils/General/FormStateHandler';
import PostEvent from '../../../../Data/PostEvents';
import SubstituteListValues from '../../../../Utils/General/SubstituteListValues';
import RightHelp from '../../../General/RightHelp/RightHelp';
import ErrorMessage from '../../../General/ErrorMessage/ErrorMessage';
import SinglePagePanel from '../../../Forms/SinglePagePanel/SinglePagePanel';
import TransformDatesInJson from '../../../../Utils/Local/TransformDatesInJson';
import TranslateTag from '../../../../Utils/Local/TranslateTag';
import PopulateFieldsWithNewContents from '../../../../Utils/PageStructure/PopulateFieldsWithNewContents';


const DirectTestsGrid = (props) => {

    const [displayHelpState, setDisplayHelpState] = useState(false);
    const [userFormState, setUserFormState] = useState({isFormOpen: false, fullScreen: false});
    const [listData, setListDataState] = useState({});
    const [errorStatus, updateErrorStatus] = useState({visible: false, message: ''});
    const [dataEntryErrorStatus, updatedataEntryErrorStatus] = useState({visible: false, message: ''});
    const [selectedRecord, setSelectedRecord] = useState({});
    const [selectedIndex, setSelectedIndex] = useState({});
    const [finishAction, setFinishAction] = useState("");
    const [dataEntryState, setDataEntryState] = useState();

    let displayType = (null);
    let recordDisplay = (null);

    useEffect(() => {
        let parameters = [{ Key: 'id', Value: props.id }];
        const criteria = { Name: props.config.QueryName, Parameters: parameters };
        Post('query/filteredget', criteria, dataReceivedHandler, errorWhenRetrievingData);
    }, [props.config.QueryName, props.id, props.refresh]);

    const closeHelpHandler = () => {
        setDisplayHelpState(false);
    }

    const closeUserFormHandler = () => {
        setUserFormState({...userFormState, isFormOpen: false, fullScreen: false, formDef: {}});
        props.containerVisibility(true);
        errorCloseHandler();
        dataEntryErrorCloseHandler();
    }

    const errorCloseHandler = () => {
        updateErrorStatus({visible: false, message: ''});
    }

    const errorWhenSavingData = (response) => {
        updatedataEntryErrorStatus({visible: true, message: response.data});
    }

    const dataEntryErrorCloseHandler = (response) => {
        updatedataEntryErrorStatus({visible: false, message: ""});
    }

    const dataReceivedHandler = (data) => {
        TransformDatesInJson(data);

        for (const record of data) {
            const form = props.forms.filter(f => f.Name === record.TestName);
            record.stateid = form.length === 0 ? "noteditable" : "edit";
            if (record.stateid === "edit") {
                const deleteForm = props.config.Id === "directtests" ? props.forms.filter(f => f.Name === 'removedirecttestform') : props.forms.filter(f => f.Name === 'removeculturetestform');
                record.stateid = deleteForm.length === 0 ? "edit" : "editanddelete";
            }
            record.Status = record.Status === "Complete" ? TranslateTag("@GenComC@", props.language) : TranslateTag("@GenReq@", props.language);
        }
        setListDataState(data);
    }

    const embeddedModeButtonHandler = (item, button) => {
        itemSelected(item, true);
        buttonClickHandler(button, item);
    }

    const buttonClickHandler = (button, item) => {
        setFinishAction(button.OnFinish);
        if (button.Key === "deletetest") {
            const form = props.config.Id === "directtests" ? props.forms.filter(f => f.Name === 'removedirecttestform') : props.forms.filter(f => f.Name === 'removeculturetestform');
            InvokeFormHandlerUsingForm(form, item.Id, dataRetrievedSuccessfully, errorWhenRetrievingData);
        } else {
            const form = props.forms.filter(f => f.Name === item.TestName);
            InvokeFormHandlerUsingForm(form, item.Id, dataRetrievedSuccessfully, errorWhenRetrievingData);
        }
    }

    const dataRetrievedSuccessfully = (data, extraInfo) => {
        const state = DataRetrievedHandler(data, extraInfo, props.forms, props.pages, props.lists);
        setDataEntryState({...state, button: extraInfo.button, fieldChanges: [] });
        setUserFormState({...userFormState, isFormOpen: true, formDef: state.formDef, fullScreen: state.formDef.fullScreenOnly});
    }

    const errorWhenRetrievingData = (response) => {
        updateErrorStatus({visible: true, message: response});
    }

    const formSaveHandler = () => {
        const state = PrepareDataFormSavingHandler(dataEntryState, "specimens");

        let refresh = "";
        if (finishAction === 'update') {
            const id = selectedRecord[0] === undefined ? 0 : selectedRecord[0].id;
            if (Object.keys(state.data).length > 3 || state.data.Crafted === undefined) {
                var rowData = SubstituteListValues(state.data, props.lists);
                const rowToChange = listData.findIndex(r => r.id === id);
                listData[rowToChange] = rowData;
            }
        } else {
            refresh = "refresh";
        }

        PostEvent(state.data, () => { eventPostedSuccessfully(refresh) }, errorWhenSavingData, state );
    }
    
    const eventPostedSuccessfully = (refresh) => {
        closeUserFormHandler();

        if (refresh === 'refresh') {

            let parameters = [{ Key: 'id', Value: props.id }];
            const criteria = { Name: props.config.QueryName, Parameters: parameters };
            Post('query/filteredget', criteria, dataReceivedHandler, errorWhenRetrievingData);

            setSelectedRecord([]);
        } 

        if (props.onRefresh !== undefined) {
            props.onRefresh();
        }
    }

    const nextButtonClickHandler = (page, fieldChangesToUse, sourceOfClick) => {
        const state = NextButtonClickHandler(page, fieldChangesToUse, sourceOfClick, dataEntryState);
 
        if (state.error !== "") {
            updatedataEntryErrorStatus({visible: true, message: state.error + TranslateTag("@ValMes@",props.language)});
        } else {
            setDataEntryState(state);
        }
    }

    const previousButtonClickHandler = (page) => {
        const state = PreviousButtonClickHandler(page, dataEntryState);
        setDataEntryState(state);
    }

    const fieldContentsChangeHandler = (id, value, extraInfo) => {
        let state = {...dataEntryState};
        if (id === "multiplechanges") {
            for (const item of value) {
                state = FieldContentsChangeHandler(item.key,item.value,extraInfo, props.lists, state);
            }
        } else {
            state = FieldContentsChangeHandler(id,value,extraInfo, props.lists, dataEntryState);
        }
        PopulateFieldsWithNewContents(state.formDef.Pages, state.fieldChanges);
        setDataEntryState(state);
    }

    const refreshForm = (button) => {
        buttonClickHandler(button);
    }

    const itemInvokedHandler = (item) => {
        let viewButton = props.config.Buttons.filter(b => b.Key === 'view')[0];
    }

    const selectionChangeHandler = (selectionState) => {
        setSelectedRecord(selectionState.getSelection());
        setSelectedIndex(selectionState.getSelectedIndices());
    }

    const itemSelected = (item, selected) => {
        if (selected) {
            var arrayOfSelectedItems = [];
            arrayOfSelectedItems[0] = item;
            setSelectedRecord(arrayOfSelectedItems);
        }
    }

    let menuButtons = [];
    let menuItems = [];

    // Should ultimately get this from workflow.
    const allowedStates = [526, 527, 529, 532, 533, 535];

    if (allowedStates.find(s => s === props.stateid) !== undefined) {
        menuButtons = [
            {Icon: "Edit", Key: "edittest", PrimaryAction: true, Text: TranslateTag("@GenEdi@",props.language), OnFinish: "refresh", EntryStates: "edit, editanddelete", Workflow: true},
            {Icon: "Delete", Key: "deletetest", PrimaryAction: true, Text: TranslateTag("@GenDel@",props.language), OnFinish: "refresh", EntryStates: "editanddelete", Workflow: true}
        ];
        menuItems = MapButtonsToContextMenu(menuButtons, buttonClickHandler);
    }

    const columns = [
        { Key: 'alert', Name: '', FieldName: '', MinWidth: 20, MaxWidth: 20, IsResizable: false, IsCollapsible: false },
        { Key: 'column1', Name: TranslateTag("@GenTesC@",props.language), FieldName: 'TestDescription', MinWidth: 180, MaxWidth: 180, IsResizable: true, IsCollapsible: false },
        { Key: 'menu', Name: '', FieldName: '', MinWidth: 120, MaxWidth: 120, IsResizable: true, IsCollapsible: false },
        { Key: 'column2', Name: TranslateTag("@GenStaA@",props.language), FieldName: 'Status', MinWidth: 200, MaxWidth: 200, IsResizable: true, IsCollapsible: true },
        { Key: 'column3', Name: TranslateTag("@GenReq@",props.language), FieldName: 'Requested', MinWidth: 180, MaxWidth: 180, IsResizable: true, IsCollapsible: true },
        { Key: 'column4', Name: TranslateTag("@GenComC@",props.language), FieldName: 'Completed', MinWidth: 200, MaxWidth: 200, IsResizable: true, IsCollapsible: true }
    ];

    if (props.passive) {
        columns.splice(2, 1);
    }

    // Filter view based on state.
    const listContentCss = ! userFormState.fullScreen ? "" : "app-invisible"

    // Don't display at all if there's no data.
    if (listData !== undefined && listData.length > 0) {
        displayType =
            <ListView 
                type={"grid"}
                columns={columns}
                listData={listData}
                menuItems={menuItems}
                itemSelected={itemSelected}
                selectedRecord={selectedIndex}
                itemInvokedHandler={itemInvokedHandler}
                selectionChanged={selectionChangeHandler}
                isDataLoaded={true}
                basic={true}
                displaySummary={true}
                basicModeButtonHandler={embeddedModeButtonHandler}>
            </ListView>
    } else {
        displayType = (
            <div className='directtestsgrid-no-list'>
                ----- {TranslateTag("@GenNon@", props.language)} -----
            </div>
        );
    }

    let dataEntryPanel = (null);
    if (userFormState.isFormOpen) {
        dataEntryPanel = (<SinglePagePanel
            id={dataEntryState.id}
            visible={true}
            currentPage={dataEntryState.currentPage}
            close={closeUserFormHandler}
            save={formSaveHandler}
            next={nextButtonClickHandler}
            previous={previousButtonClickHandler}
            config={userFormState.formDef}
            fullScreen={userFormState.fullScreen}
            changeHandler={fieldContentsChangeHandler}
            errorCloseHandler={dataEntryErrorCloseHandler}
            refresh={refreshForm}
            language={props.language}
            error={dataEntryErrorStatus}>
        </SinglePagePanel>);
    }

    return (
        <div className='directtestsgrid-content'>
            <div className={listContentCss}>
                {displayType}
            </div>
            {recordDisplay}
            {dataEntryPanel}
            <RightHelp visible={displayHelpState} closed={closeHelpHandler}></RightHelp>
            <ErrorMessage visible={errorStatus.visible} dismissHandler={errorCloseHandler} error={errorStatus.message}></ErrorMessage>
        </div>
    )
};

const mapStateToProps = state => {
    return {
        uievents: state.config.uievents,
        forms: state.config.forms,
        pages: state.config.pages,
        lists: state.config.lists,
        showFullScreen: state.display.showFullScreen,
    };
}

export default connect(mapStateToProps)(DirectTestsGrid);